import { render, staticRenderFns } from "./CreateRecord.vue?vue&type=template&id=423024ab&scoped=true"
import script from "./CreateRecord.vue?vue&type=script&lang=ts"
export * from "./CreateRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423024ab",
  null
  
)

export default component.exports